import styles from "./home.module.css";

const linkSets = {
  pearson: [
    { label: "MyLab", url: "https://pearsonmylab.magicedtech.com/" },
    { label: "eText", url: "https://pearsonetext.magicedtech.com/" },
    { label: "Video", url: "https://pearsonvideo.magicedtech.com/" },
    { label: "Document", url: "https://pearsondocuments.magicedtech.com/" },
  ],
  hmh: [
    { label: "External QA", url: "https://hmh.magicedtech.com/" },
    { label: "Internal QA", url: "https://hmh-internal.magicedtech.com/" },
  ],
};

const PopupHealthDashboard = ({ closePopup, token, popupType }) => {
  const links = linkSets[popupType] ?? [];

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <button
          className={styles.closeButton}
          onClick={closePopup}
          aria-label="Close"
        >
          ✖
        </button>
        <div className={styles.popupContent}>
          {links.map(({ label, url }) => (
            <a
              key={label}
              target="_blank"
              rel="noopener noreferrer"
              href={`${url}?token=${token}`}
              className={styles.tilePopup}
            >
              <div>
                <p className={styles.smallText2}>{label}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PopupHealthDashboard;